import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import InterventionTime from "./InterventionTime";
import Remarks from "./Remarks";
import SubmissionDocuments from "./SubmissionDocuments";
import TriggeredFireProtectionSystems from "./TriggeredFireProtectionSystems";

const SubmissionDocumentsTab: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    return <>
        <SettingsCol >
            <SettingsLabel text={"[REACT_SYSTEM_DOCUMENTATION]"} labelPosition={'floating'} lines={'none'} />
            <SubmissionDocuments systemId={systemId} />

        </SettingsCol>
        <SettingsCol >
            <SettingsLabel text={"[REACT_DELAY_TIME]"} labelPosition={'floating'} lines={'none'} />
            <InterventionTime systemId={systemId} />
        </SettingsCol>
        <SettingsCol >
            <SettingsLabel text={"[REACT_ACTUATED_FIRE_PROTECTION_SYSTEMS]"} labelPosition={'floating'} lines={'none'} />
            <TriggeredFireProtectionSystems systemId={systemId} />
            <SettingsLabel text={"TRVB_COMMENT_LABEL"} labelPosition={'floating'} lines={'none'} />
            <Remarks systemId={systemId} />
        </SettingsCol>
    </>;
};

export default SubmissionDocumentsTab;
